export const AXIOS_BASE_URL =
  typeof windows !== undefined && !window.location.href.includes("localhost:")
    ? "https://feeder-node-1337.herokuapp.com"
    : "http://localhost:5000";
